import { ReportCustomizationReducerAction } from "@app/report-customization/build-reports/interfaces/reportCustomizationReducerAction";
import { ReportCustomizationReducerActions } from "@app/report-customization/build-reports/interfaces/reportCustomizationReducerActionsEnum";
import { ReportCustomizationState } from "@app/report-customization/build-reports/interfaces/reportCustomizationState";

export const reportCustomizationReducer: React.Reducer<ReportCustomizationState, ReportCustomizationReducerAction> = (state, action) => {
  switch (action.type) {
    case ReportCustomizationReducerActions.ChangeAppendNextClosestProviders:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ReportCustomizationReducerActions.ChangeAppendPatternOfCare:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ReportCustomizationReducerActions.ChangeFileFormat:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ReportCustomizationReducerActions.ChangeChangedGapsFilter:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ReportCustomizationReducerActions.ChangeExcludeZeroMembership:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ReportCustomizationReducerActions.ChangeFilename:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ReportCustomizationReducerActions.ChangeIncludeActive:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ReportCustomizationReducerActions.ChangeIncludeApproved:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ReportCustomizationReducerActions.ChangeIncludeCargo:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ReportCustomizationReducerActions.ChangeIncludeExpandableSpecialties:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ReportCustomizationReducerActions.ChangeIncludeFacilitySpecialties:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ReportCustomizationReducerActions.ChangeIncludeOpportunity:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ReportCustomizationReducerActions.ChangeIncludePending:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ReportCustomizationReducerActions.ChangeIncludePhysicianSpecialties:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ReportCustomizationReducerActions.ChangeIsCompareMode:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ReportCustomizationReducerActions.ChangeIsGenerating:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ReportCustomizationReducerActions.ChangeLoadedPresets:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ReportCustomizationReducerActions.ChangeMemberships:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ReportCustomizationReducerActions.ChangeOnlyShowSpecialtiesNotMeetingAccess:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ReportCustomizationReducerActions.ChangeProviderFilter:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ReportCustomizationReducerActions.ChangeProviderSource:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ReportCustomizationReducerActions.ChangeRunFrequency:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ReportCustomizationReducerActions.ChangeReportFormat:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ReportCustomizationReducerActions.ChangeReportType:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ReportCustomizationReducerActions.ChangeSelectedPreset:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ReportCustomizationReducerActions.ChangeSelectedCounties:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ReportCustomizationReducerActions.ChangeSelectedCareJourneyCostValues:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ReportCustomizationReducerActions.ChangeSelectedCareJourneyQualityValues:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ReportCustomizationReducerActions.ChangeSelectedEffectivenessValues:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ReportCustomizationReducerActions.ChangeSelectedEfficiencyValues:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ReportCustomizationReducerActions.ChangeSelectedLineOfBusiness:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ReportCustomizationReducerActions.ChangeSelectedLocationConfidenceValues:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ReportCustomizationReducerActions.ChangeSelectedMotiveAppropriatenessValues:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ReportCustomizationReducerActions.ChangeSelectedNewPatientClaimsValues:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ReportCustomizationReducerActions.ChangeSelectedVolumeLabels:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ReportCustomizationReducerActions.ChangeSelectedSpecialties:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ReportCustomizationReducerActions.ChangeSelectedStates:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ReportCustomizationReducerActions.ChangeSelectedZipClasses:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ReportCustomizationReducerActions.ChangeServiceAreaGapsType:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ReportCustomizationReducerActions.ChangeSharedUsers:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ReportCustomizationReducerActions.ChangeShouldEmailLink:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ReportCustomizationReducerActions.ChangeShowAddedProviders:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ReportCustomizationReducerActions.ChangeShowMatchedProviders:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ReportCustomizationReducerActions.ChangeShowRemovedProviders:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ReportCustomizationReducerActions.ChangeSpecialtyGapsType:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ReportCustomizationReducerActions.ChangeTimeslice:
    case ReportCustomizationReducerActions.ChangeComparedTimeslice:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ReportCustomizationReducerActions.LoadPage:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    default:
      return state;
  }
}